<template>
  <SidebarLayout>
    <!-- Sidebar -->
    <template v-slot:sidebar="{ sidebar }">
      <div class="d-flex flex-column my-4">
        <v-btn v-for="item in menu" :key="item.tab" text :block="sidebar" @click="tab = item.tab" :icon="!sidebar" color="white" :title="item.title" :class="['mb-4', sidebar ? 'left-align-btn' : 'mx-auto']">
          <v-icon :left="sidebar">{{ item.icon }}</v-icon> <span v-if="sidebar">{{ item.title }}</span>
        </v-btn>
      </div>
    </template>
    <!-- Main -->
    <template v-slot:main>
      <ConundrumCreator v-if="tab === 0" />
      <ConundrumPreview v-if="tab === 1" />
      <ConundrumEditor v-if="tab === 2" />
      <ConundrumSettings v-if="tab === 3" />
    </template>
  </SidebarLayout>
</template>

<script>
import { doc, getDoc } from 'firebase/firestore'
import { db } from '@/firebase/init'

import SidebarLayout from '@/layouts/Sidebar.vue';
import ConundrumCreator from '@/components/conundrums/ConundrumCreator.vue';
import ConundrumPreview from '@/components/conundrums/ConundrumPreview.vue';
import ConundrumEditor from '@/components/conundrums/ConundrumEditor.vue';
import ConundrumSettings from '@/components/conundrums/ConundrumSettings.vue';

export default {
  name: 'RealmConundrum',
  
  components: {
    SidebarLayout,
    ConundrumCreator,
    ConundrumPreview,
    ConundrumEditor,
    ConundrumSettings,
  },

  data() {
    return {
      tab: 0,
      conundrum: null,
      loading: false,
      sparkyCollapsed: false,
      menu: [
        { title: 'Creator', icon: 'mdi-creation', tab: 0 },
        { title: 'Preview', icon: 'mdi-controller', tab: 1 },
        { title: 'Editor', icon: 'mdi-file-document-edit-outline', tab: 2 },
        { title: 'Settings', icon: 'mdi-cog-outline', tab: 3 },
      ],
    }
  },

  methods: {
    intitialize() {
      this.loading = true;
      let conundrumId = this.$route.params.id;
        if (conundrumId) {
        this.loadConundrum(conundrumId);
      } else {
        this.loading = false;
        // Or handle creation of a new idea if that's a possible use case
        console.log("No conundrum ID found in route params.");
      }
    },

    loadConundrum(conundrumId) {
      const conundrumRef = doc(db, 'conundrums', conundrumId);
      getDoc(conundrumRef).then((doc) => {
        if (doc.exists()) {
          this.conundrum = { id: doc.id, ...doc.data() };
        } else {
          console.error("No such conundrum document!");
          this.conundrum = null;
        }
        this.loading = false;
      }).catch(error => {
        console.error("Error getting document:", error);
        this.loading = false;
      });
    },

    saveConundrum() {
      console.log('TODO: implement save for conundrum', this.conundrum?.id)
    },
  },

  mounted() {
    this.intitialize()
  }
}
</script>